module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donation-supporter-details",
    attrs: {
      "id": "donate-step2"
    }
  }, [_c('h2', [_vm._v("Your details")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "checkbox"
  }, [_vm._v("\n      " + _vm._s(_vm.product.producttype == "adoption" ? "Adopt" : "Donate") + " on behalf\n      of a business\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.isBehalfBusiness),
      expression: "donation.isBehalfBusiness"
    }],
    attrs: {
      "type": "checkbox",
      "id": "isBehalfBusiness",
      "name": "isBehalfBusiness"
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.isBehalfBusiness) ? _vm._i(_vm.donation.isBehalfBusiness, null) > -1 : (_vm.donation.isBehalfBusiness)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.isBehalfBusiness,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.isBehalfBusiness = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.isBehalfBusiness = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "isBehalfBusiness", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })])]), _vm._v(" "), (_vm.donation.isBehalfBusiness) ? _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.bussiness.name),
      expression: "donation.bussiness.name"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('businessName'),
        empty: !_vm.donation.bussiness.name,
    },
    attrs: {
      "name": "businessName",
      "type": "text",
      "autocomplete": "organization"
    },
    domProps: {
      "value": (_vm.donation.bussiness.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation.bussiness, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "businessName"
    }
  }, [_vm._v("Business Name")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.title),
      expression: "donation.title"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('title'), empty: !_vm.donation.title
    },
    attrs: {
      "name": "title",
      "autocomplete": "honorific-prefix"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.donation, "title", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Dr"
    }
  }, [_vm._v("Dr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Miss"
    }
  }, [_vm._v("Miss")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mr"
    }
  }, [_vm._v("Mr")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mrs"
    }
  }, [_vm._v("Mrs")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Ms"
    }
  }, [_vm._v("Ms")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Mx"
    }
  }, [_vm._v("Mx")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "title"
    }
  }, [_vm._v("Select a title")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.firstname),
      expression: "donation.firstname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('firstName'), empty: !_vm.donation.firstname
    },
    attrs: {
      "name": "firstName",
      "type": "text",
      "autocomplete": "given-name"
    },
    domProps: {
      "value": (_vm.donation.firstname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "firstname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "firstName"
    }
  }, [_vm._v("First Name")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.lastname),
      expression: "donation.lastname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      error: _vm.errors.has('lastName'), empty: !_vm.donation.lastname
    },
    attrs: {
      "name": "lastName",
      "type": "text",
      "autocomplete": "family-name"
    },
    domProps: {
      "value": (_vm.donation.lastname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "lastname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lastName"
    }
  }, [_vm._v("Last Name")])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.phone),
      expression: "donation.phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        donationValidatePhone: true
      }),
      expression: "{ required: true, donationValidatePhone: true }"
    }],
    class: {
      error: _vm.errors.has('phone'),
        empty: !_vm.donation.phone,
    },
    attrs: {
      "name": "phone",
      "type": "tel",
      "min": "8",
      "max": "12",
      "autocomplete": "tel"
    },
    domProps: {
      "value": (_vm.donation.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "phone", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.has('phone')) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.errors.first("phone")) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "wwf-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.email),
      expression: "donation.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        donationValidateEmail: true
      }),
      expression: "{ required: true, donationValidateEmail: true }"
    }],
    class: {
      error: _vm.errors.has('email') || _vm.errors.has('donationValidateEmail'),
        empty: !_vm.donation.email,
    },
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "autocomplete": "email"
    },
    domProps: {
      "value": (_vm.donation.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.donation, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('span', {
    staticClass: "wwf-alert"
  }, [(_vm.errors.firstByRule('email', 'donationValidateEmail')) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.errors.first("email")) + "\n      ")]) : _vm._e()])]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_vm._v("\n    Stay up to date by receiving emails\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.optin),
      expression: "donation.optin"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.optin) ? _vm._i(_vm.donation.optin, null) > -1 : (_vm.donation.optin)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.optin,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.optin = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.optin = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "optin", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('label', {
    staticClass: "checkbox"
  }, [_vm._v("\n    I'm interested to donate in my will\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.bequest),
      expression: "donation.bequest"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.bequest) ? _vm._i(_vm.donation.bequest, null) > -1 : (_vm.donation.bequest)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.bequest,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.bequest = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.bequest = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "bequest", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('h2', [_vm._v("Your address")]), _vm._v(" "), (_vm.showRecipientCheckbox) ? _c('label', {
    staticClass: "checkbox"
  }, [_vm._v("\n    Same as Recipient\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.donation.isSameAddress),
      expression: "donation.isSameAddress"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.donation.isSameAddress) ? _vm._i(_vm.donation.isSameAddress, null) > -1 : (_vm.donation.isSameAddress)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.donation.isSameAddress,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.donation.isSameAddress = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.donation.isSameAddress = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.donation, "isSameAddress", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]) : _vm._e(), _vm._v(" "), (_vm.cannotDeliver) ? _c('div', {
    staticClass: "cannot-deliver"
  }, [_vm._v("\n    We're sorry, gifts and toy products can only be delivered within\n    Australia.\n  ")]) : _vm._e(), _vm._v(" "), _c('AddressInput', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showRecipientCheckbox || !_vm.donation.isSameAddress),
      expression: "!showRecipientCheckbox || !donation.isSameAddress"
    }],
    ref: "AddressInput"
  }), _vm._v(" "), _c('button', {
    staticClass: "plain",
    attrs: {
      "name": "goto-payment",
      "type": "button",
      "href": "#form-top"
    },
    on: {
      "click": function($event) {
        _vm.next()
      }
    }
  }, [(_vm.donation.payementType === 'wwf_paypal') ? _c('span', [_vm._v("Pay with PayPal")]) : _vm._e(), _vm._v(" "), (_vm.donation.payementType !== 'wwf_paypal') ? _c('span', [_vm._v("Go to Payment")]) : _vm._e(), _vm._v(" "), _vm._m(0, false, false)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-arrow-right"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1b13e55e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=os8u77dxteg!./~/string-replace-webpack-plugin/loader.js?id=zkc3fbyssup!./src/components/donation/SupporterDetails.vue
// module id = 620
// module chunks = 0